import MainPage from "./components/main-page/main-page.component";

function App() {
  return (
    <MainPage/>
  );
}

export default App;
